module.exports = __webpack_public_path__ + "img/logo6.913bdd2a.png";